<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="-margin-md">メッセージ一覧</HeadingOne>

    <section>
      <ListGroup
        v-if="noticeList.length > 0"
        class="-link -visited _mb-sm-60 _mb-md-120"
      >
        <ListItem
          v-for="(notice, index) in noticeList"
          :key="index"
          class="-link"
          :class="{ unread: notice.disp_status == '0' }"
          router-name="mb003"
          :params="{ notice_id: notice.notice_id }"
        >
          <span class="date -db">{{
            ymdDateFormat(notice.notice_date || "", "/")
          }}</span>
          {{ notice.notice_title }}
        </ListItem>
      </ListGroup>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { getNoticeListLambdaInvoke } from "@/utils/LambdaHelper";
import HeadingOne from "@/components/heading/HeadingOne";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { ymdDateFormat } from "@/utils/Filter";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";

export default {
  name: "Mb002",
  components: {
    ListItem,
    ListGroup,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "メッセージ一覧",
      description: "description",
      content:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,メッセージ",
    });

    return {
      ymdDateFormat,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "メッセージ",
          active: true,
        },
      ],
      noticeList: [],
      // noticeList: [{
      //   notice_id: '',
      //   notice_date: '',
      //   disp_status: '',
      //   importance: '',
      //   notice_title: ''
      // }]
    };
  },
  mounted() {
    try {
      getNoticeListLambdaInvoke()
        .then((res) => {
          let resBody = JSON.parse(res.body);
          this.noticeList = resBody.notices || [];
          this.sortNotice();
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    sortNotice() {
      this.noticeList.sort(function (a, b) {
        // 未読 > 日付
        if (a.disp_status < b.disp_status) return -1;
        if (a.disp_status > b.disp_status) return 1;
        if (a.notice_date < b.notice_date) return 1;
        if (a.notice_date > b.notice_date) return -1;
        return 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.border-bottom {
  border-bottom: 1px $black dotted;
  margin-bottom: 10px;
  a:hover {
    color: $orange;
    text-decoration: underline;
  }
}
</style>
